module.exports = __webpack_public_path__ + "img/logo-bigcommerce.00865c3a.png";